import {Permissions} from "@/js/Permissions";

const PolarisRoutes = [
  {
    path: "/airs/criminal",
    name: "criminal_index",
    component: () => import("@/views/airs/criminal/IndexView.vue"),
    meta: {permissions: [Permissions.AIRS]},
  },
  {
    path: "/airs/criminal/review",
    name: "criminal_review_index",
    component: () => import("@/views/airs/criminal/ReviewIndexView.vue"),
    meta: {permissions: [Permissions.AIRS]},
  },
  {
    path: "/airs/criminal/review/batch-review",
    name: "criminal_batch_review",
    component: () => import("@/views/airs/criminal/BatchReviewView.vue"),
    meta: {permissions: [Permissions.AIRS]},
  },
  {
    path: "/airs/criminal/create",
    name: "criminal_create",
    component: () => import("@/views/airs/criminal/CreateView.vue"),
    meta: {permissions: [Permissions.AIRS]},
  },
  {
    path: "/airs/criminal/import-history",
    name: "criminal_import_history",
    component: () => import("@/views/airs/criminal/ImportHistoryView.vue"),
    meta: {permissions: [Permissions.AIRS]},
  },
  {
    path: "/airs/criminal/import-history/import",
    name: "criminal_import",
    component: () => import("@/views/airs/criminal/ImportView.vue"),
    meta: {permissions: [Permissions.AIRS]},
  },
  {
    path: "/airs/criminal/import-history/import/:id/headers",
    name: "criminal_import_headers",
    component: () => import("@/views/airs/criminal/ImportHeadersView.vue"),
    meta: {permissions: [Permissions.AIRS]},
  },
  {
    path: "/airs/criminal/import-history/import/:id/mapping",
    name: "criminal_import_mapping",
    component: () => import("@/views/airs/criminal/ImportMappingView.vue"),
    meta: {permissions: [Permissions.AIRS]},
  },
  {
    path: "/airs/criminal/import-history/import/:id/preview",
    name: "criminal_import_preview",
    component: () => import("@/views/airs/criminal/ImportPreviewView.vue"),
    meta: {permissions: [Permissions.AIRS]},
  },
  {
    path: "/airs/criminal/:id",
    name: "criminal_edit",
    component: () => import("@/views/airs/criminal/EditView.vue"),
    meta: {permissions: [Permissions.AIRS]},
  },
]

export default PolarisRoutes;
